import React, { useState, useEffect } from 'react';
import '../styles/loginForm.scss';
import api from '../api';
const loginImage = `${process.env.PUBLIC_URL}/assets/background_polos.png`;

const Login = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const [imageLoaded, setImageLoaded] = useState(false);

  // Função para pré-carregar a imagem
  const preloadImage = (src) => {
    return new Promise((resolve) => {
      const img = new Image();
      img.src = src;
      img.onload = () => resolve();
    });
  };

  useEffect(() => {
    // Pré-carregando a imagem
    preloadImage(loginImage).then(() => {
      setImageLoaded(true);
    });
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    try {
      const response = await api.post('/auth/login', {
        username,
        password,
      });

      localStorage.setItem('token', response.data.token);
      alert('Login bem-sucedido!');
      window.location.href = '/dashboard';
    } catch (err) {
      setError(err.response ? err.response.data.message : 'Erro ao fazer login');
    }
  };

  const handleCreateAccount = () => {
    window.location.href = '/register';
  };

  return (
    <div className="login-container">
      {!imageLoaded && <div className="loading">Carregando...</div>}
      {imageLoaded && (
        <>
          <div className="login-form">
            <h2>Login</h2>
            <form onSubmit={handleSubmit}>
              <div>
                <label htmlFor="username">Usuário:</label>
                <input
                  type="text"
                  id="username"
                  value={username}
                  onChange={(e) => setUsername(e.target.value)}
                  required
                />
              </div>
              <div>
                <label htmlFor="password">Senha:</label>
                <input
                  type="password"
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  required
                />
              </div>
              <button type="submit">Entrar</button>
              <button className='register-button' onClick={handleCreateAccount} type="button">Criar Conta</button>
              {error && <p>{error}</p>}
            </form>
          </div>
          <div className="login-image">
            <img src={loginImage} alt="Imagem de Login" />
          </div>
        </>
      )}
    </div>
  );
};

export default Login;
